import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Alert, Box, Snackbar, Stack, TextField, Typography } from '@mui/material';
import { FlowBreadcrumbs, FlowFormCard, SubmitButton, mediaPreviewStyles } from './FlowLayout';
import { fetchDestinationHierarchy } from './flowHierarchy';

const AddItinerary = () => {
  const { destinations_id } = useParams();
  const navigate = useNavigate();
  const [hierarchy, setHierarchy] = useState({
    destinationName: '',
    tourTypeId: '',
    tourTypeName: '',
    continentId: '',
    continentName: ''
  });
  const [tabHeading, setTabHeading] = useState('');
  const [descriptionHeading, setDescriptionHeading] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  React.useEffect(() => {
    fetchDestinationHierarchy(destinations_id)
      .then((response) => setHierarchy(response))
      .catch((error) => console.error('There was an error fetching the destination context!', error));
  }, [destinations_id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    const formData = new FormData();
    formData.append('destinations_id', destinations_id);
    formData.append('tab_heading', tabHeading);
    formData.append('description_heading', descriptionHeading);
    formData.append('description', description);
    formData.append('image', image);

    try {
      await axios.post('https://aaryanholidays.in/backend/itineraries', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setSnackbar({ open: true, message: 'Itinerary added successfully.', severity: 'success' });
      navigate(`/manage-destination/itineraries/${destinations_id}`);
    } catch (error) {
      console.error('There was an error adding the itinerary!', error);
      setSnackbar({ open: true, message: 'There was an error adding the itinerary.', severity: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box>
      <FlowBreadcrumbs items={[{ label: 'Tour Management', to: '/manage-continents' }, { label: hierarchy.continentName || 'Continent', to: hierarchy.continentId ? `/manage-tour-type/${hierarchy.continentId}` : undefined }, { label: hierarchy.tourTypeName || 'Country', to: hierarchy.tourTypeId ? `/manage-destination/${hierarchy.tourTypeId}` : undefined }, { label: hierarchy.destinationName || 'Package', to: hierarchy.tourTypeId ? `/manage-destination/${hierarchy.tourTypeId}` : undefined }, { label: 'Itineraries', to: `/manage-destination/itineraries/${destinations_id}` }, { label: 'Add Itinerary' }]} />
      <FlowFormCard title="Add Itinerary" subtitle="Add a well-structured content tab with a strong headline, summary, and supporting visual.">
        <form onSubmit={handleSubmit}>
          <Stack spacing={2.5}>
            <TextField label="Tab Heading" value={tabHeading} onChange={(e) => setTabHeading(e.target.value)} fullWidth required />
            <TextField label="Description Heading" value={descriptionHeading} onChange={(e) => setDescriptionHeading(e.target.value)} fullWidth required />
            <TextField label="Description" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth multiline rows={5} required />
            <Box>
              <input id="itinerary-image" type="file" hidden accept="image/*" onChange={(e) => {
                const file = e.target.files[0];
                setImage(file);
                setImagePreview(file ? URL.createObjectURL(file) : null);
              }} />
              <label htmlFor="itinerary-image">
                <SubmitButton component="span" variant="outlined">
                  Upload Image
                </SubmitButton>
              </label>
            </Box>
            {imagePreview ? (
              <Box>
                <Typography variant="body2" sx={{ mb: 1, color: '#64748b' }}>Preview</Typography>
                <img src={imagePreview} alt="Itinerary preview" style={mediaPreviewStyles} />
              </Box>
            ) : null}
            <SubmitButton type="submit" variant="contained" loading={submitting}>
              Create Itinerary
            </SubmitButton>
          </Stack>
        </form>
      </FlowFormCard>
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddItinerary;
